import env from '../env.js'
import countries from './db/countries.js'
import { getUserData } from '@/helpers/utils'

const state = {
    isLoading: false,
    AppActiveUser: getUserData(),
    domain: env.domain,
    localUserKey: env.localUserKey,
    appName: env.appName,
    config:{
        shortDesc: "Top-rated branding agency."
    },
    windowWidth: null,
    countries: countries,
    reviews : [],
    coupons : [],
}

export default state
